import React, { createContext, useState, useMemo } from 'react';

interface DashboardCtx {
    deleteSuccessful: boolean;
    handleCloseSuccessModal: (action: React.Dispatch<React.SetStateAction<boolean>>) => void;
    handleOpenSuccessModal: (action: React.Dispatch<React.SetStateAction<boolean>>) => void;
    setDeleteSuccessful: React.Dispatch<React.SetStateAction<boolean>>;
    setIsContactUpdateSuccess: React.Dispatch<React.SetStateAction<boolean>>;
    isContactUpdateSuccess: boolean;
    withdrawSuccessful: boolean;
    setWithdrawSuccessful: React.Dispatch<React.SetStateAction<boolean>>;
    withdrawnApplicationType: string;
    setWithdrawnApplicationType: React.Dispatch<React.SetStateAction<string>>;
    setIsEditSuccess: React.Dispatch<React.SetStateAction<boolean>>;
    isEditSuccess: boolean;
    setSelectedAction: React.Dispatch<
        React.SetStateAction<{
            isOpen: boolean;
            title: string;
            id: string;
        }>
    >;
    selectedAction: {
        isOpen: boolean;
        title: string;
        id: string;
    };
}
const DashboardContext = createContext<DashboardCtx | null>(null);

export function Provider({ children }: { children: React.ReactNode }) {
    const [deleteSuccessful, setDeleteSuccessful] = useState(false);
    const [isContactUpdateSuccess, setIsContactUpdateSuccess] = useState(false);
    const [withdrawSuccessful, setWithdrawSuccessful] = useState(false);
    const [withdrawnApplicationType, setWithdrawnApplicationType] = useState('');
    const [isEditSuccess, setIsEditSuccess] = useState(false);
    const [selectedAction, setSelectedAction] = useState({
        isOpen: false,
        title: '',
        id: ''
    });

    const handleOpenSuccessModal = (action: React.Dispatch<React.SetStateAction<boolean>>) => action(true);
    const handleCloseSuccessModal = (action: React.Dispatch<React.SetStateAction<boolean>>) => action(false);

    const ctxValue = useMemo(() => {
        return {
            deleteSuccessful,
            handleCloseSuccessModal,
            handleOpenSuccessModal,
            setDeleteSuccessful,
            setIsContactUpdateSuccess,
            isContactUpdateSuccess,
            withdrawSuccessful,
            setWithdrawSuccessful,
            withdrawnApplicationType,
            setWithdrawnApplicationType,
            setIsEditSuccess,
            isEditSuccess,
            setSelectedAction,
            selectedAction
        };
    }, [deleteSuccessful, isContactUpdateSuccess, withdrawSuccessful, withdrawnApplicationType, isEditSuccess, selectedAction]);
    return <DashboardContext.Provider value={ctxValue}>{children}</DashboardContext.Provider>;
}

export default DashboardContext;
